export default "__VITE_ASSET__DsyMAkXS__"